import { useMemo } from "react"

import { RootState, selectTokenDecimals, useDappSelector } from "#/redux-state"
import { FRIENDLY_DECIMALS_AMOUNT } from "#/shared/constants"
import { SwappableToken } from "#/shared/types"
import {
  bigIntToHumanReadableFormat,
  floatToBigInt,
  getCurrencySymbol,
} from "#/shared/utils"

type SwapModalValueProps = {
  amountIn: string
  amountOut: string
  tokenIn: SwappableToken
  tokenOut: SwappableToken
}

type SwapModalValueContentProps = {
  amount: string
  decimals: number
  token: SwappableToken
}

function SwapModalValueContent({
  amount,
  decimals,
  token,
}: SwapModalValueContentProps) {
  const formattedAmount = useMemo(
    () =>
      bigIntToHumanReadableFormat(
        floatToBigInt(amount, decimals),
        decimals,
        FRIENDLY_DECIMALS_AMOUNT,
      ),
    [amount, decimals],
  )

  return (
    <>
      {formattedAmount} {getCurrencySymbol(token)}
    </>
  )
}

export default function SwapModalValue({
  amountIn,
  amountOut,
  tokenIn,
  tokenOut,
}: SwapModalValueProps) {
  const tokenInDecimals = useDappSelector((state: RootState) =>
    selectTokenDecimals(state, tokenIn),
  )

  const tokenOutDecimals = useDappSelector((state: RootState) =>
    selectTokenDecimals(state, tokenOut),
  )

  return (
    <>
      <SwapModalValueContent
        amount={amountIn}
        decimals={tokenInDecimals}
        token={tokenIn}
      />
      <br />
      for{" "}
      <SwapModalValueContent
        amount={amountOut}
        decimals={tokenOutDecimals}
        token={tokenOut}
      />
    </>
  )
}
